module.exports = "<div class=\"m-control\"></div>";